import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '../store'
import PortalRoutes from '../modules/portal/routes'
import AuthRoutes from '../modules/auth-service/auth/routes'
import UserManagementRoutes from '../modules/auth-service/user-management/routes'
import organizationProfileRoutes from '../modules/common-config/org-profile/routes'
import organogramRoutes from '../modules/common-config/organogram/routes'
import complainRoutes from '../modules/common-config/complain/routes'
import notificationRoutes from '../modules/common-config/notification/routes'
import paymentManagementRoutes from '../modules/common-config/payment-management/routes'
import ExternalUserRoutes from '../modules/external-user-service/routes'
import documentRoutes from '../modules/common-config/document/routes'
import dataArchiveRoutes from '../modules/common-config/data-archive/routes'
import CommitteeRoutes from '../modules/common-config/committee/routes'
import infoServiceManagementRoutes from '../modules/common-config/info-service-management/routes'
import productionConfigurationRoutes from '../modules/production-service/configuration/routes'
import hospitalConfigurationRoutes from '../modules/hospital-disability-service/configuration/routes'
import childConfigurationRoutes from '../modules/child-service/configuration/routes'
import childInstituteManagementRoutes from '../modules/child-service/institute-management/routes'
import childLegalInstituteManagementRoutes from '../modules/child-service/legal-institute-management/routes'
import childRehabilitationManagementRoutes from '../modules/child-service/rehabilitation-management/routes'
import productionStoreManageRoutes from '../modules/production-service/store-management/routes'
import hospitalInformationRoutes from '../modules/hospital-disability-service/information/routes'
import childEducationManagementRoutes from '../modules/child-service/educational-management/routes'
import childReportsRoutes from '../modules/child-service/reports/routes'
import productionRetailerDealerRoutes from '../modules/production-service/retailer-dealer-management/routes'
import salesDistributionAdminRoutes from '../modules/production-service/sales-distribution-admin/routes'
import salesCenterRoutes from '../modules/production-service/sales-center/routes'
import childAddmissionManagementRoutes from '../modules/child-service/child-admission-management/routes'
import hospitalSocialServiceRoutes from '../modules/hospital-disability-service/social-service/routes'
import hospitalStoreManagementRoutes from '../modules/hospital-disability-service/store-management/routes'
import hospitalInformationManagementRoutes from '../modules/hospital-disability-service/billing-information-management/routes'
import consultancyTherapyCenterRoutes from '../modules/hospital-disability-service/consultancy-therapy-center/routes'
import thirtyPercentRoutes from '../modules/hospital-disability-service/thirty-percent/configuration/routes'
import productionPromotionManagementRoutes from '../modules/production-service/promotion-management/routes'
import hospitalPublicPanelRoutes from '../modules/hospital-disability-service/public-panel/routes'
import grantAllowanceConfigurationRoutes from '../modules/grant-allowance-service/configuration/routes'
import grantAllowanceBudgetManagementRoutes from '../modules/grant-allowance-service/budget-management/routes'
import grantAllowanceProcessRoutes from '../modules/grant-allowance-service/process/routes'
import grantAllowanceRegistrationManagement from '../modules/grant-allowance-service/registration-management/routes'
import grantAllowancePaymentManagement from '../modules/grant-allowance-service/payment-management/routes'
import grantAllowanceServiceMonitoring from '../modules/grant-allowance-service/performance-monitoring/routes'
import grantAllowanceCitizenRoutes from '../modules/grant-allowance-service/citizen-card/routes'
import grantAllowanceSocialOrganizationRoutes from '../modules/grant-allowance-service/social-organization/routes'
// /** Social Welfare Service */
import socialWelfareServiceConfigurationRoutes from '../modules/social-welfare-service/configuration/routes'
import socialWelfareServiceManualContentManagementRoutes from '../modules/social-welfare-service/manual-content-management/routes'
/** Awareness Event Service */
import awarenessEventConfig from '../modules/awareness-event-service/configuration/routes'
import awarenessEventManagementSystem from '../modules/awareness-event-service/event-management-system/routes'
import awarenessEventInfoManagementSystem from '../modules/awareness-event-service/info-management-system/routes'
import awarenessEventJobFairManagement from '../modules/awareness-event-service/job-fair-management/routes'
import awarenessEventAssistiveDeviceManagement from '../modules/awareness-event-service/assistive-device-management/routes'
import assistiveDeviceDeliveryAndDistributionManagement from '../modules/awareness-event-service/assistive-device-delivery-and-distribution-management/routes'
/** Disability School Service */
import disabilitySchoolConfiguration from '../modules/disability-school-service/configuration/routes'
import disabilitySchoolInstitute from '../modules/disability-school-service/institute-management/routes'
import disabilitySchoolStudent from '../modules/disability-school-service/student-management/routes'
import disabilitySchoolOnlineAdmission from '../modules/disability-school-service/admission-management/routes'
import disabilityExamAndResult from '../modules/disability-school-service/exam-result-management/routes'
import disabilitySchoolReports from '../modules/disability-school-service/report/routes'
/** Portal Routes */
/** Training Service */
import trainingConfigurationRoutes from '../modules/training-e-learning-service/configuration/routes'
import trainingReportManagementRoutes from '../modules/training-e-learning-service/report-management/routes'
import trainingInformationApplicationManagementRoutes from '../modules/training-e-learning-service/information-application-management/routes'
import trainerTraineeInfoManagementRoutes from '../modules/training-e-learning-service/trainer-trainee-info-management/routes'
import trainingPlanManagementRoutes from '../modules/training-e-learning-service/training-plan-management/routes'
import trainingAccommodationManagementRoutes from '../modules/training-e-learning-service/accommodation-management/routes'

import CommonPortalRoutes from '../modules/common-config/portal/routes'
import ApiManagerRoutes from '../modules/common-config/api-manager/routes'

import streetChildrenConfig from '../modules/street-children-service/configuration/routes'
import streetChildrenMain from '../modules/street-children-service/street-children/routes'
import streetChildrenReport from '../modules/street-children-service/report/routes'

import rehabilitationVagrantConfig from '../modules/rehabilitation-vagrant-service/configuration/routes'
import rehabilitationVagrantMain from '../modules/rehabilitation-vagrant-service/vagrant/routes'
import rehabilitationVagrantReport from '../modules/rehabilitation-vagrant-service/report/routes'

/* Layouts */
const AuthSignUpLayout = () => import('../layouts/auth-layouts/AuthSignupLayout.vue')
const NotFoundPage = () => import('../views/Pages/ErrorPage.vue')

Vue.use(VueRouter)

const childRoutes = (prop) => [
  {
    path: '',
    // name: prop + '.home-2',
    // meta: { auth: true, name: 'Home 2' },
    // component: Dashboard2,
    redirect: '/portal/home'
  },
  {
    path: '/home',
    // name: prop + '.home-2',
    // meta: { auth: true, name: 'Home 2' },
    // component: Dashboard2,
    redirect: { name: 'authSignUp.dashboard' }
  }
]

const defaultRoutes = [
  {
    path: '',
    name: 'dashboard',
    component: AuthSignUpLayout,
    meta: { auth: true },
    children: childRoutes('dashboard')
  },
  {
    path: '/production-service',
    name: 'production_service',
    component: () => import('@/layouts/ProductionLayout'),
    meta: { auth: true },
    children: [
      {
        path: 'dashboard',
        name: 'production_service.dashboard',
        component: () => import('@/views/services-main-dashboard/ProductionService.vue')
      }
    ]
  },
  {
    path: '/hospital-disability-service',
    name: 'hospital_disability_service',
    component: () => import('@/layouts/HospitalDisabilityService'),
    meta: { auth: true },
    children: [
      {
        path: 'dashboard',
        name: 'hospital_disability_service.dashboard',
        component: () => import('@/views/services-main-dashboard/HospitalDisabilityService.vue')
      },
      {
        path: 'thirty-pc-dashboard',
        name: 'hospital_disability_service.thirty_pc_dashboard',
        component: () => import('@/views/services-main-dashboard/JointlyFormatedHospital.vue')
      }
    ]
  },
  {
    path: '/child-service',
    name: 'child_service',
    component: () => import('@/layouts/ChildServiceLayout'),
    meta: { auth: true },
    children: [
      {
        path: 'dashboard',
        name: 'child_service.dashboard',
        component: () => import('@/views/services-main-dashboard/ChildService.vue')
      }
    ]
  },
  {
    path: '/grant-allowance-service',
    name: 'grant_allowance_service',
    component: () => import('@/layouts/GrantAllowanceLayout.vue'),
    meta: { auth: true },
    children: [
      {
        path: 'dashboard',
        name: 'grant_allowance_service.dashboard',
        component: () => import('@/views/services-main-dashboard/GrantAllowance.vue')
      }
    ]
  },
  {
    path: '/social-welfare-service',
    name: 'social_welfare_service',
    component: () => import('@/layouts/SocialWelfareServiceLayout.vue'),
    meta: { auth: true },
    children: [
      {
        path: 'dashboard',
        name: 'social_welfare_service.dashboard',
        component: () => import('@/views/services-main-dashboard/SocialWelfareService.vue')
      }
    ]
  },
  {
    path: '/awareness-event-service',
    name: 'awareness_event_service',
    component: () => import('@/layouts/AwarenessEventLayout.vue'),
    meta: { auth: true },
    children: [
      {
        path: 'dashboard',
        name: 'awareness_event_service.dashboard',
        component: () => import('@/views/services-main-dashboard/AwarenessEventService.vue')
      }
    ]
  },
  {
    path: '/training-e-learning-service',
    name: 'training_e_learning_service',
    component: () => import('@/layouts/TrainingElearningLayout.vue'),
    meta: { auth: true },
    children: [
      {
        path: 'dashboard',
        name: 'training_e_learning.dashboard',
        component: () => import('@/views/services-main-dashboard/TrainingElearningLayout.vue')
      }
    ]
  },
  {
    path: '/disability-school-service',
    name: 'disability_school_service',
    component: () => import('@/layouts/DisabilitySchoolLayout.vue'),
    meta: { auth: true },
    children: [
      {
        path: 'dashboard',
        name: 'disability_school_service.dashboard',
        component: () => import('@/views/services-main-dashboard/DisabilitySchoolService.vue')
      }
    ]
  },
  {
      path: '*',
      meta: { auth: false },
      component: NotFoundPage
  }
]

const routes = [
  ...defaultRoutes,
  ...PortalRoutes,
  ...ApiManagerRoutes,
  ...AuthRoutes,
  ...UserManagementRoutes,
  ...organizationProfileRoutes,
  ...organogramRoutes,
  ...complainRoutes,
  ...notificationRoutes,
  ...paymentManagementRoutes,
  ...ExternalUserRoutes,
  ...documentRoutes,
  ...dataArchiveRoutes,
  ...CommitteeRoutes,
  ...infoServiceManagementRoutes,
  ...productionConfigurationRoutes,
  ...hospitalConfigurationRoutes,
  ...childConfigurationRoutes,
  ...childInstituteManagementRoutes,
  ...childLegalInstituteManagementRoutes,
  ...productionStoreManageRoutes,
  ...hospitalInformationRoutes,
  ...childRehabilitationManagementRoutes,
  ...childEducationManagementRoutes,
  ...childReportsRoutes,
  ...productionRetailerDealerRoutes,
  ...salesDistributionAdminRoutes,
  ...salesCenterRoutes,
  ...childRehabilitationManagementRoutes,
  ...childRehabilitationManagementRoutes,
  ...childAddmissionManagementRoutes,
  ...hospitalSocialServiceRoutes,
  ...hospitalStoreManagementRoutes,
  ...consultancyTherapyCenterRoutes,
  ...thirtyPercentRoutes,
  ...productionPromotionManagementRoutes,
  ...hospitalPublicPanelRoutes,
  ...hospitalInformationManagementRoutes,
  ...grantAllowanceBudgetManagementRoutes,
  ...grantAllowanceConfigurationRoutes,
  ...grantAllowanceProcessRoutes,
  ...grantAllowanceRegistrationManagement,
  ...grantAllowancePaymentManagement,
  ...grantAllowanceServiceMonitoring,
  ...grantAllowanceCitizenRoutes,
  ...grantAllowanceSocialOrganizationRoutes,
  ...CommonPortalRoutes,
  /** Social Welfare Service */
  ...socialWelfareServiceConfigurationRoutes,
  ...socialWelfareServiceManualContentManagementRoutes,
  /** Disability School Service */
  ...disabilitySchoolConfiguration,
  ...disabilitySchoolInstitute,
  ...disabilitySchoolStudent,
  ...disabilitySchoolOnlineAdmission,
  ...disabilityExamAndResult,
  ...disabilitySchoolReports,
  /** Awareness Event Service */
  ...awarenessEventConfig,
  ...awarenessEventManagementSystem,
  ...awarenessEventInfoManagementSystem,
  ...awarenessEventJobFairManagement,
  ...awarenessEventAssistiveDeviceManagement,
  ...assistiveDeviceDeliveryAndDistributionManagement,
  /** Training Service */
  ...trainingConfigurationRoutes,
  ...trainingReportManagementRoutes,
  ...trainingInformationApplicationManagementRoutes,
  ...trainerTraineeInfoManagementRoutes,
  ...trainingPlanManagementRoutes,
  ...trainingAccommodationManagementRoutes,
  ...streetChildrenConfig,
  ...streetChildrenReport,
  ...streetChildrenMain,
  ...rehabilitationVagrantConfig,
  ...rehabilitationVagrantReport,
  ...rehabilitationVagrantMain
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (window.location.hostname === '114.130.119.224') {
    window.location.href =
      'https://mswservices.gov.bd' +
      window.location.pathname +
      window.location.search
    return
  }
  if (to.matched.some(record => record.meta.auth)) {
    const accessToken = localStorage.getItem('access_token')
    const authUser = Store.state.Auth.authUser
    // Deliberately NOT checking the access token's own expires_in timestamp
    // here anymore - the access token is meant to be a short-lived,
    // silently-rotated implementation detail under the refresh-token system
    // (see sessionHeartbeat.js / api_config.js), not the actual session
    // deadline. Forcing a logout the instant its 15-minute clock passes,
    // on every navigation, bypassed that entirely: it fired even when the
    // refresh token was still perfectly valid and the heartbeat had already
    // renewed (or was about to renew) the session. Real expiry is already
    // handled at the API layer via the 401-retry-and-refresh in
    // api_config.js's execute(), which actually checks with the server
    // instead of trusting the client's own clock.
    if (!accessToken && authUser) {
      return next({ path: '/auth/login' })
    } else if (!accessToken && !authUser) {
      return next({ path: '/auth/login' })
    } else if (accessToken && !authUser) {
      return next({ path: '/auth/login' })
    } else {
      return next()
    }
  }
  next()
})

router.afterEach(() => {
  Vue.nextTick(() => {
    window.requestAnimationFrame(() => {
      const logoElement = document.querySelector('.initial-focus')
      if (!logoElement) return

      // Ensure programmatic focus works consistently across routes/layouts.
      if (!logoElement.hasAttribute('tabindex')) {
        logoElement.setAttribute('tabindex', '-1')
      }

      logoElement.focus({ preventScroll: true })
    })
  })
})

export default router
